import { Textarea } from '@chakra-ui/react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import DrawerDialog from '@/components/drawer'
import { Button } from '@/components/ui/button'
import { DrawerBody, DrawerFooter, DrawerHeader } from '@/components/ui/drawer'
import { Text } from '@/components/ui/typography'
import useColorModeValue from '@/hooks/useColorModeValue'
import { ITopic } from '@/types/helpCenter'

import Acordition from '../acordition'

const HelpCenterDrawer = ({
    isOpen,
    onClose,
    handleSend,
    selectedTopic,
}: {
    isOpen: boolean
    handleSend: (message: string) => void
    onClose: () => void
    selectedTopic: ITopic | null
}) => {
    const [message, setMessage] = useState('')
    const { t } = useTranslation()
    const borderColor = useColorModeValue('gray.300', 'gray.700')

    const onSend = () => {
        handleSend(message)
        setMessage('')
    }

    return (
        <DrawerDialog isOpen={isOpen} onClose={onClose}>
            <DrawerHeader px="0" py="24px">
                <Text>{selectedTopic?.name}</Text>
            </DrawerHeader>
            <DrawerBody px="0" pb="24px" pt="0">
                <Acordition resources={selectedTopic?.description} />
                <Text fontSize={14} pb="16px" fontWeight="bold">
                    {t('global.helpCenter.drawer.body.message')}
                </Text>
                <Textarea
                    onChange={(e) => setMessage(e.target.value)}
                    variant="gsk"
                    style={{ caretColor: 'var(--chakra-colors-orange-400)' }}
                    maxH="90%"
                    minH="250px"
                />
            </DrawerBody>
            <DrawerFooter borderTopWidth="1px" borderColor={borderColor} justifyContent="flex-start" px="0" py="32px">
                <Button variant="secondary" mr="18px" onClick={onClose}>
                    {t('global.helpCenter.drawer.buttons.cancel')}
                </Button>
                <Button variant="primary" onClick={onSend} disabled={!message}>
                    {t('global.helpCenter.drawer.buttons.send')}
                </Button>
            </DrawerFooter>
        </DrawerDialog>
    )
}

export default HelpCenterDrawer
